import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	card: {
		background: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		padding: spacing.lg,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
	},
	headerRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: spacing.md,
	},
	titleRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
	},
	titleIcon: {
		color: colors.primary.main,
		flexShrink: 0,
	},
	title: {
		fontFamily: typography.fontFamilies.sora,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
		margin: 0,
	},
	statusRow: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.md,
	},
	verifiedAt: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	bodyRow: {
		display: 'flex',
		gap: spacing.sm,
		fontSize: typography.fontSizes.sm,
		alignItems: 'baseline',
	},
	bodyLabel: {
		color: colors.text.light,
	},
	bodyValue: {
		color: colors.text.main,
		fontWeight: typography.fontWeights.semibold,
	},
	bodyId: {
		color: colors.text.main,
	},
	helpText: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		lineHeight: 1.5,
	},
	errorText: {
		color: colors.danger.dark,
		fontSize: typography.fontSizes.sm,
		fontFamily: 'monospace',
		whiteSpace: 'pre-wrap',
		wordBreak: 'break-word',
		background: colors.danger.light,
		padding: spacing.sm,
		borderRadius: common.borderRadius,
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	skeletonBar: {
		background: colors.background.main,
		borderRadius: common.borderRadius,
		height: 14,
	},
	skeletonBarWide: {
		width: '60%',
	},
	skeletonBarNarrow: {
		width: '40%',
	},
});
